import SimpleShow from './SimpleShow';

export default SimpleShow;
